export enum MutationTypesContractor {
    SET_CONTRACTOR = 'SET_CONTRACTOR',
    SET_CONTRACTORS = 'SET_CONTRACTORS',
    SET_REVIEW_CONTRACTOR = 'SET_REVIEW_CONTRACTOR',
}